import { bootstrapShopifyAnalytics } from "./bootstrap";

let attached = false;

function attach() {
  if (attached) return true;

  const existingBus = window.Shopify?.analytics;
  if (!existingBus) {
    return false;
  }

  bootstrapShopifyAnalytics(existingBus);
  attached = true;
  return true;
}

(function init() {
  if (typeof window === "undefined") return;

  if (attach()) return;

  // If the analytics bus is provided by a module/defer script, it will be
  // available before DOMContentLoaded.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attach, { once: true });
  }
})();
